import { Flex, Tabs } from 'antd'
import React, { createElement, ReactNode, useCallback, useEffect, useState } from 'react'

import Page from '@/components/shared/page'
import { FeatureKey } from '@/constants/feature-key'
import { readAllCreators } from '@/redux/creator-actions'
import { setFeatureKeys } from '@/redux/global'
import { useAppDispatch } from '@/redux/utils'

import CreatorReportsOverview from './creator-reports-overview'
import s from './creator-reports.module.css'
import {
  ReportsPageProps,
  useReportSearch,
} from './hooks/use-report-search'

const tabPagesConfig: Record<string, (props: ReportsPageProps) => ReactNode> = {
  [FeatureKey.AnalyticsCreatorOverview]: CreatorReportsOverview,
}

const tabItems = [
  { key: FeatureKey.AnalyticsCreatorOverview, label: 'Overview' },
]

export default function CreatorReportsPage() {
  const [currentMenuKey, setCurrentMenuKey] = useState(tabItems[0].key)
  const dispatch = useAppDispatch()

  const { searchValues, searchElements } = useReportSearch({
    enableCreatorsFilter: currentMenuKey === FeatureKey.AnalyticsCreatorOverview,
    enableEarningTypeSelect: true,
  })

  useEffect(() => {
    dispatch(setFeatureKeys([FeatureKey.Analytics, FeatureKey.CreatorReports, currentMenuKey]))
  }, [currentMenuKey, dispatch])

  const onTabChange = useCallback((activeKey: string) => {
    setCurrentMenuKey(activeKey as FeatureKey)
  }, [])

  useEffect(() => {
    void dispatch(readAllCreators({ permissionKey: currentMenuKey }))
  }, [dispatch, currentMenuKey])

  return (
    <Page contentClassName={s.creatorReportsContent}>
      <Tabs
        className={s.tabs}
        tabBarExtraContent={searchElements}
        items={tabItems}
        activeKey={currentMenuKey}
        onChange={onTabChange}
      />
      <Flex vertical className={s.tabContent}>
        {createElement(tabPagesConfig[currentMenuKey], {
          searchValues,
        })}
      </Flex>
    </Page>
  )
}
